import { useInView } from "@/hooks/useInView";

import { FeatureCardList } from "@/components/landing/FeatureCardList";
import { RevealText } from "@/components/landing/RevealText";

const phone = "/images/landing/security/phone.png";

const CARDS = [
  {
    title: "Spider подключается по API",
    text: "Взаимодействие происходит по зашифрованному защищенному протоколу напрямую с биржей.",
  },
  {
    title: "Ключи с доступом на вывод отклоняются",
    text: "Система автоматически блокирует ключи, если в них включена функция снятия средств.",
  },
  {
    title: "Бот торгует, но не выводит",
    text: "Математически невозможно перевести деньги на сторонние адреса через интерфейс бота.",
  },
  {
    title: "Остановка в любой момент",
    text: "Один клик отзывает права доступа у бота, закрывая все открытые позиции.",
  },
];

export const SecuritySection = () => {
  // За колонкой, а не за телефоном: наблюдатель учитывает обрезку родителем
  const [columnRef, isColumnVisible] = useInView<HTMLDivElement>({
    once: true,
    rootMargin: "0px 0px -45% 0px",
  });

  return (
    <section
      id="security"
      className="border-landing-line scroll-mt-[5.625rem] border-b"
    >
      <div className="landing-container flex flex-col gap-12 py-[12.5rem] max-md:gap-10 max-md:py-20 lg:flex-row">
        <div
          ref={columnRef}
          // basis-0 в колонке даёт нулевую высоту: контейнер тянется по контенту
          className="relative flex flex-1 basis-0 flex-col items-center overflow-hidden max-lg:flex-none max-lg:basis-auto"
        >
          {/* Окно обрезки: режем по границе рядов (y=220 из 441), чтобы не резать иконки */}
          <div
            aria-hidden
            className="pointer-events-none absolute bottom-0 left-0 aspect-[992/441] w-full max-w-[31rem] overflow-hidden max-lg:max-w-none min-[32rem]:max-lg:aspect-[992/217]"
          >
            <div className="landing-pattern absolute bottom-0 left-0 aspect-[992/441] w-full">
              <div className="landing-pattern-sheen" />
            </div>
          </div>
          <RevealText
            as="h2"
            className="text-landing-ink relative text-center text-[1.5rem] leading-[1.4] font-semibold max-md:text-[1.25rem]"
          >
            Деньги остаются на твоей бирже
          </RevealText>
          {/* 594:398 — верхние 42% снимка: сумма и график целиком, кнопки за кадром */}
          <div
            data-revealed={isColumnVisible ? "" : undefined}
            className="landing-rise relative mt-[4.75rem] w-[18.5625rem] max-w-[70%] max-lg:aspect-[594/398] max-lg:overflow-hidden max-md:mt-6 max-md:w-[min(20rem,78%)] max-md:max-w-none"
          >
            <img
              src={phone}
              alt="Кошелёк на бирже: баланс $6,389.61"
              className="w-full select-none"
            />
          </div>
        </div>

        <FeatureCardList
          cards={CARDS}
          className="flex flex-1 basis-0 flex-col gap-6 max-lg:flex-none max-lg:basis-auto"
        />
      </div>
    </section>
  );
};
